import React, { useState } from 'react';
import { Box, Button, ButtonGroup, CircularProgress, makeStyles, Paper } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { useSelector } from 'react-redux';
import { RootState } from 'interfaces';
import { USER_OPERATIONS } from 'helper';
import { RealEstateEventDialog, RealEstateEvent } from './components';
import { useLoadRealEstateEvents, useLoadRealEstateEventTypes } from './hooks';

const useStyles = makeStyles({
  root: {
    position: 'relative',
    maxWidth: 1366,
  },
  loader: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    zIndex: 1000,
  },
});

interface IProps {
  realEstateId: string;
}

const View: React.FC<IProps> = ({ realEstateId }) => {
  // Global data
  const operations = useSelector((state: RootState) => state.operations);

  // Local state
  const [realEstateEventDialogOpened, setRealEstateEventDialogOpened] = useState(false);
  const [onlyActive, setOnlyActive] = useState(true);

  // Styles
  const classes = useStyles();

  const { realEstateEvents, loadEventsState, fetchRealEstateEvents } = useLoadRealEstateEvents(
    realEstateId,
    onlyActive,
  );
  const { realEstateEventTypes } = useLoadRealEstateEventTypes();

  return (
    <>
      <Box className={classes.root}>
        {operations.includes(USER_OPERATIONS.REAL_ESTATE_EVENT_OPERATION) && (
          <Box sx={{ mb: 2 }}>
            <ButtonGroup>
              <Button variant="outlined" onClick={() => setRealEstateEventDialogOpened(true)} startIcon={<Add />}>
                Добавить событие
              </Button>

              {onlyActive && (
                <Button variant="outlined" onClick={() => setOnlyActive(false)}>
                  Показать все события
                </Button>
              )}
            </ButtonGroup>
          </Box>
        )}

        {loadEventsState.loading ? (
          <Paper variant="outlined">
            <Box sx={{ position: 'relative', p: 5 }}>
              <Box className={classes.loader}>
                <CircularProgress />
              </Box>
            </Box>
          </Paper>
        ) : realEstateEvents.length ? (
          <>
            <Box sx={{ mt: 2 }}>
              {realEstateEvents
                .sort((x, y) => (x.active === y.active ? 0 : x.active ? -1 : 1))
                .map((realEstateEvent) => (
                  <RealEstateEvent
                    key={realEstateEvent.realEstateEventId}
                    realEstateId={realEstateId}
                    realEstateEvent={realEstateEvent}
                    realEstateEventTypes={realEstateEventTypes}
                    onCreateOrUpdate={fetchRealEstateEvents}
                  />
                ))}
            </Box>
          </>
        ) : null}
      </Box>

      <RealEstateEventDialog
        open={realEstateEventDialogOpened}
        realEstateId={realEstateId}
        realEstateEventTypes={realEstateEventTypes}
        onClose={() => setRealEstateEventDialogOpened(false)}
        onCreateOrUpdate={fetchRealEstateEvents}
      />
    </>
  );
};

export default View;
